<template>
  <button id="KEY_D" name="D" class="btn softkey-btn" aria-label="D" data-vcode="COLOR_KEY_3">
    <img src="/images/icn-softkey-D.svg" alt="" role="img" aria-hidden="true" />
  </button>
</template>
<script>
export default {};
</script>
